import { useMemo } from 'react';

import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';
import { useLivePageMode } from '@confluence/live-pages-utils/entry-points/useLivePagesStore.ts';
import { useIsEditorPage } from '@confluence/route-manager/entry-points/useIsEditorPage.ts';

export const usePageAnalyticsAttributes = () => {
	const isLivePage = useIsCurrentPageLive();
	const [{ mode: livePageMode }] = useLivePageMode();
	const isEditorPage = useIsEditorPage();

	return useMemo(() => {
		if (isLivePage) {
			return {
				isLivePage,
				pageMode: livePageMode || 'view', // 'edit' or 'view' for live pages
			};
		} else {
			return {
				isLivePage,
				pageMode: isEditorPage ? 'edit' : 'view', // 'edit' or 'view' for classic pages
			};
		}
	}, [isLivePage, livePageMode, isEditorPage]);
};
